export default __webpack_public_path__ + "static/media/welding2.f8d3f542.png";